import React from 'react';

class Dates extends React.Component {
    render(){
        return (
            <div className = "datesContent">
                <div className="pageTitle"><h2>Litter Pick Dates</h2></div>
                <div className="pageContent">
                    <p>The following dates have been scheduled for 2026.</p>
                    <p>All dates and times are subject to change at short notice - adverse weather may require last minute changes or cancellations.</p>
                    <p>Please check before attending. Updates will be sent to the email list and posted on facebook.</p>
                    <br /><br/>
                    <div className="desktop">
                        <table aria-label="Event dates">
                            <thead>
                                <tr>
                                    <th>Day</th>
                                    <th>Date</th>
                                    <th>Start</th>
                                    <th>End</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="past">
                                    <td>Saturday</td>
                                    <td>24th January</td>
                                    <td>10am</td>
                                    <td>12pm CANCELLED</td>
                                </tr>
                                <tr className="past">
                                    <td>Saturday</td>
                                    <td>21st February</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr className="past">
                                    <td>Saturday</td>
                                    <td>28th March</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr className="next">
                                    <td>Saturday</td>
                                    <td>25th April</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>16th May</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>27th June</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>18th July</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>15th August</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>26th September</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr> 
                                    <td>Saturday</td>
                                    <td>24th October</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>21st November</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>12th December</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                                <tr>
                                    <td>Saturday</td>
                                    <td>30th January 2027</td>
                                    <td>10am</td>
                                    <td>12pm</td>
                                </tr>
                            </tbody>
                        </table>
                        <br/><br/>
                    </div>
                    <div className="mobile">
                        <p className="dateLine past">
                            Saturday 24th January
                            <br/>
                            10.00am - 12.00pm - CANCELLED
                            <br/>
                        </p>
                        <p className="dateLine past">
                            Saturday 21st February
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine past">
                            Saturday 28th March
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine next">
                            Saturday 25th April
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 16th May
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 27th June
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 18th July
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 15th August
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 26th September
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 24th October
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 21st November
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 12th December
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                        <p className="dateLine">
                            Saturday 30th January 2027
                            <br/>
                            10.00am - 12.00pm
                            <br/>
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Dates;